import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import choose1 from "../../../assets/choose1.webp";
import choose2 from "../../../assets/choose2.webp";
import choose3 from "../../../assets/choose3.webp";
import choose4 from "../../../assets/choose4.webp";
import choose5 from "../../../assets/choose5.webp";
// import choose6 from "../../../assets/choose6.webp";
import choose7 from "../../../assets/choose7.webp";
import choose8 from "../../../assets/choose8.webp";
import choose9 from "../../../assets/choose9.webp";
import choose10 from "../../../assets/choose10.png";

const Chooseus = () => {
  return (
    <>
      <div className="chooseus">
        <Container>
          <Row>
            <Col md={12}>
              <div className="Button_healthy">
                <span className="lets">Why Choose Sharva Clinic? </span>
              </div>
              <div className="main_head mt-5">
                <h2>Our Distinctive Advantages </h2>
              </div>
              <div className="main_p mt-3">
                <p>
                  Expertise, Compassion, and Excellence: Your Pathway to Optimal{" "}
                  <br /> Health and Timeless Beauty.
                </p>
              </div>
            </Col>
          </Row>
          <div className="choose_us_points my-5">
            <Row>
              <Col md={4}>
                <div className="choose_card1 my-3">
                  <div className="choose_head">
                    <h6>Facelifts & Contouring </h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      Sculpt and redefine your features with advanced facelift
                      and contouring treatments at the best skin care clinic in
                      Pitampura. Experience natural-looking rejuvenation with
                      expert precision
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img src={choose1} alt="Facelift Surgery in Delhi" />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="/drSweta/facelift"
                    >
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="choose_card2 my-3">
                  <div className="choose_head">
                    <h6>Lip Enhancement </h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      Achieve beautifully enhanced, well-defined lips with safe
                      and precise lip enhancement procedures. At our best
                      multispeciality clinic in Pitampura, we help you
                      rediscover natural beauty with expert care
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img src={choose2} alt="Lip Surgery in Delhi" />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a style={{ textDecoration: "none" }} href="/drSweta/lip">
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="choose_card3 my-3">
                  <div className="choose_head">
                    <h6>Dermal Fillers </h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      Restore youthful radiance and smooth fine lines with
                      professionally delivered dermal fillers treatment. As the
                      best skin care clinic in Pitampura, we ensure natural,
                      subtle, and long-lasting rejuvenation.
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img
                      src={choose3}
                      alt="best dermal fillers treatment in Delhi"
                    />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="/drSweta/dermal"
                    >
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <div className="choose_card4 my-3">
                  <div className="choose_head">
                    <h6>Asthma Management </h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      Breathe freely with personalised asthma treatment designed
                      by the best asthma doctor in Pitampura. We focus on
                      long-term control, fewer attacks, and improved respiratory
                      health
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img src={choose4} alt="top asthma clinic in Delhi" />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="/drgaurav/asthma"
                    >
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="choose_card5 my-3">
                  <div className="choose_head">
                    <h6>COPD Care </h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      Get advanced COPD care from expert pulmonologists at the
                      best multispeciality clinic in Pitampura. Improve lung
                      function, enhance wellness, and regain active living with
                      specialised treatment plans.
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img src={choose5} alt="COPD Treatment in Delhi" />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a style={{ textDecoration: "none" }} href="/drgaurav/copd">
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="choose_card6 my-3">
                  <div className="choose_head">
                    <h6>Skin Treatment </h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      Achieve radiant skin with our innovative therapies!
                      Ranging from acne treatment to anti-aging remedies,we
                      provide tailored solutions for vibrant, healthy skin
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img src={choose10} alt="Skin Treatment in Delhi" />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="/drSweta/pigmentation"
                    >
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <div className="choose_card1 my-3">
                  <div className="choose_head">
                    <h6>Other Respiratory Diseases</h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      At Sharva Clinic, expert pulmonologists provide advanced
                      care for a wide range of respiratory conditions, including
                      lung infections, interstitial lung disease, and pulmonary
                      fibrosis. As the best multispeciality clinic in Pitampura,
                      we offer expert treatment of respiratory issues with
                      accurate diagnosis and personalised care.
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img
                      src={choose7}
                      alt="expert treatment of respiratory issues"
                    />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="/drgaurav/respiratory"
                    >
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="choose_card2 my-3">
                  <div className="choose_head">
                    <h6>Allergy/Sinus</h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      Our pulmonology team delivers specialised care for
                      allergies and sinus problems, helping relieve congestion,
                      sneezing, sinus pressure, and breathing difficulties.
                      Recognised for expert allergy treatment in Delhi, Sharva
                      Clinic ensures long-term relief with advanced and
                      personalised care
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img
                      src={choose8}
                      alt="expert allergy treatment in delhi"
                    />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="/drgaurav/allergies"
                    >
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="choose_card3 my-3">
                  <div className="choose_head">
                    <h6>Diabetes (Pulmonology-related</h6>
                  </div>
                  <div className="choose_p pt-3">
                    <p>
                      For diabetic patients, our pulmonologists provide
                      specialised support to manage respiratory complications
                      such as pulmonary infections and diabetic ketoacidosis. As
                      a trusted healthcare centre in Pitampura, we ensure
                      comprehensive monitoring and treatment tailored to
                      diabetic respiratory needs.
                    </p>
                  </div>
                  <div className="choose_icon">
                    <img src={choose9} alt="diabetes specialist in delhi" />
                  </div>
                  <div className="doc_btn pt-1" style={{ marginTop: "20px" }}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="/drgaurav/diabetes"
                    >
                      <Button>Read More</Button>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Chooseus;
